import { render, staticRenderFns } from "./FolderGridItem.vue?vue&type=template&id=c936a87a"
import script from "./FolderGridItem.vue?vue&type=script&lang=js"
export * from "./FolderGridItem.vue?vue&type=script&lang=js"
import style0 from "./FolderGridItem.vue?vue&type=style&index=0&id=c936a87a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports